export default getAnexosFormData;


function getAnexosFormData(anexos){

	let form = new FormData();

	for(let anexo of anexos){

		if (anexo.id === 0 && anexo.file !== null) {
			form.append(anexo.id_anexo+"_new_files[]",anexo.file);
		} else {
			form.append("anexo[]", anexo.id);
			form.append('file_'+anexo.id,anexo.file);
			form.append('file_url_'+anexo.id,anexo.url_arquivo);			
		}
	}


	return form;
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/adm_prospecto/modules/validations/module_anexos_para_formdata.js